import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axiosConfig';

export const fetchProducts = createAsyncThunk(
  'products/fetchProducts',
  async (arg) => {
    const { page = 1, limit = 50 } = arg || {};
    const response = await axios.get(`/merchants/products?page=${page}&limit=${limit}`);
    return response.data; // { products, total, page, limit }
  }
);

export const createProduct = createAsyncThunk(
  'products/createProduct',
  async ({product}) => {
    const response = await axios.post(`/merchants/products`, product);
    return response.data;
  }
);

export const updateProduct = createAsyncThunk(
  'products/updateProduct',
  async ({ id, product }) => {
    try {
      const response = await axios.put(
        `/merchants/products/${id}`,
        product
      );
      return response.data;
    } catch (error) {
      console.error('Update product error:', error.response?.data || error.message);
      throw error;
    }
  }
);

export const deleteProduct = createAsyncThunk(
  'products/deleteProduct',
  async ({ id }) => {
    const response = await axios.delete(
      `/merchants/products/${id}`
    );
    return { id, message: response.data.message };
  }
);


const productSlice = createSlice({
  name: 'products',
  initialState: {
    products: [],
    totalSold: 0,
    status: 'idle',
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => { state.status = 'loading'; })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const payload = action.payload;
        state.products = Array.isArray(payload) ? payload : (payload.products || []);
        if (!Array.isArray(payload)) {
          state.total = payload.total;
          state.totalSold = payload.totalSold || 0;
          state.page = payload.page;
          state.limit = payload.limit;
        }
      })
      .addCase(fetchProducts.rejected, (state, action) => { state.status = 'failed'; state.error = action.error.message; })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.products = [...state.products, action.payload];
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.products.findIndex(p => p.id === updated.id || p._id === updated._id);
        if (index !== -1) {
          state.products[index] = updated;
        }
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.products = state.products.filter(p => p.id !== action.payload.id && p._id !== action.payload.id);
      });

  },
});

export default productSlice.reducer;